var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-drawer",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.drawer,
            size: "80%",
            wrapperClosable: false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "form-center",
            },
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    model: _vm.form,
                    "label-width": "100px",
                    rules: _vm.rules,
                    disabled: _vm.disabled,
                  },
                },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "盘点单号", prop: "Code" } },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "盘点单号" },
                                model: {
                                  value: _vm.form.Code,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "Code", $$v)
                                  },
                                  expression: "form.Code",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "盘点时间", prop: "CheckTime" } },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  "value-format": "yyyy-MM-dd",
                                  type: "date",
                                  placeholder: "请选择日期",
                                },
                                model: {
                                  value: _vm.form.CheckTime,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "CheckTime", $$v)
                                  },
                                  expression: "form.CheckTime",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "备注", prop: "Remarks" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  placeholder: "",
                                  rows: "3",
                                  resize: "none",
                                },
                                model: {
                                  value: _vm.form.Remarks,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "Remarks", $$v)
                                  },
                                  expression: "form.Remarks",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticStyle: { "line-height": "30px" } },
                [
                  !_vm.disabled
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary", icon: "el-icon-plus\n" },
                          on: { click: _vm.addList },
                        },
                        [_vm._v("获取库存")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "el-table",
                {
                  ref: "dialogTable",
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.form.detailList,
                    height: "calc(100% - 100px)",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "序号", width: "50", type: "index" },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "备件编号",
                      align: "center",
                      prop: "Code",
                      sortable: "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "备件名称",
                      align: "center",
                      prop: "Name",
                      sortable: "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "备件类型",
                      align: "center",
                      prop: "MaterialTypeName",
                      sortable: "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "备件规格",
                      align: "center",
                      prop: "Spec",
                      sortable: "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "单位",
                      align: "center",
                      prop: "storageName",
                      sortable: "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "货位",
                      align: "center",
                      prop: "LocalName",
                      sortable: "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "库存数量",
                      align: "center",
                      prop: "Nums",
                      sortable: "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "盘点数量",
                      align: "center",
                      prop: "CheckQty",
                      sortable: "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-input", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                type: "number",
                                disabled: _vm.disabled,
                                controls: false,
                              },
                              model: {
                                value: scope.row.CheckQty,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "CheckQty", $$v)
                                },
                                expression: "scope.row.CheckQty",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm.title == "盘点详情"
                    ? _c("el-table-column", {
                        attrs: {
                          label: "盘亏/盘赢数量",
                          align: "center",
                          prop: "DifferenceQty",
                          sortable: "",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "span",
                                    {
                                      style: `color: ${_vm.color(
                                        scope.row.DifferenceQty
                                      )}`,
                                    },
                                    [_vm._v(_vm._s(scope.row.DifferenceQty))]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2137634841
                        ),
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.close } }, [_vm._v("取消")]),
              !_vm.disabled
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleSubmit },
                    },
                    [_vm._v("保存")]
                  )
                : _vm._e(),
              _vm.title == "确认盘点"
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "success" },
                      on: { click: _vm.handleAudit },
                    },
                    [_vm._v(" 确认盘点")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }